import React from "react";
import { Drawer } from "Components/Base/Navigation/Drawer";
import BaseGrid from "Components/Fragment/BaseGrid";
import FilterHitCount from "./FilterHitCount";
import FilterSection from "./FilterSection";
import SelectFilter from "./SelectFilter";
import * as CONSTANTS from "../../../constants";
import { useFilter } from "../context";

const DrawerFilters = ({
  hitCount,
  showHitCount,
  languageContext,
  mobile = false,
}) => {
  const { state, closeDrawer, setFilterStatus, setSortBy } = useFilter();

  return (
    <Drawer anchor="right" open={state.drawerOpen} onClose={closeDrawer}>
      <div
        className={`course-filter`}
        role="search"
        style={{ minWidth: "250px", maxWidth: "250px", padding: "0 2vw" }}
      >
        <BaseGrid
          childWidth="auto"
          justifyContent="space-between"
          alignItems="center"
        >
          <h2>{languageContext("filter")}</h2>
          <FilterHitCount
            hitCount={hitCount}
            languageContext={languageContext}
            showHitCount={showHitCount}
          />
        </BaseGrid>
        {mobile && (
          <BaseGrid childWidth="auto" spacing={2}>
            <SelectFilter
              name={languageContext("status")}
              options={CONSTANTS.SORT_OPTIONS_STATUS}
              value={state.status.toLowerCase()}
              onChange={setFilterStatus}
              languageContext={languageContext}
              className="filter-select"
            />
            <SelectFilter
              name={languageContext("sort")}
              options={CONSTANTS.SORT_OPTIONS_ORDER}
              value={state.sortBy}
              onChange={setSortBy}
              languageContext={languageContext}
              className="filter-select"
            />
          </BaseGrid>
        )}
        <BaseGrid childWidth="auto" direction="column">
          <FilterSection languageContext={languageContext} />
        </BaseGrid>
      </div>
    </Drawer>
  );
};

export default DrawerFilters;
